import React, {Component} from "react";

export default class SvgShapes extends Component{
    render() {
        const {color, width, height} = this.props;
        return (
            <svg width={width} height={height} viewBox="0 0 32 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className='header-icons-theme-svg' fillRule="evenodd" clipRule="evenodd" d="M15.158 0L5.89499 15.1577H24.4211L15.158 0ZM15.158 6.46715L18.4085 11.7892H11.8907L15.158 6.46715ZM24.4211 18.5262C20.2275 18.5262 16.8423 21.9115 16.8423 26.1051C16.8423 30.2987 20.2275 33.6839 24.4211 33.6839C28.6148 33.6839 32 30.2987 32 26.1051C32 21.9115 28.6148 18.5262 24.4211 18.5262ZM24.4211 30.3155C22.0969 30.3155 20.2106 28.4292 20.2106 26.105C20.2106 23.7809 22.0969 21.8946 24.4211 21.8946C26.7453 21.8946 28.6316 23.7809 28.6316 26.105C28.6316 28.4292 26.7453 30.3155 24.4211 30.3155ZM0.000244141 32.8417H13.4738V19.3682H0.000244141V32.8417ZM3.36859 22.7365H10.1053V29.4733H3.36859V22.7365Z"
                      fill={color}
                />
            </svg>
        )
    }
}
